module.exports = __webpack_public_path__ + "static/tyabe-2b9fef776e234deaa35b3d76ca41958f.png";